module.exports = __webpack_public_path__ + "img/fluent-light.32ebbec2.png";